import React, { useContext, useEffect, useState } from "react";
import Header from "../Header";
import AppContext from "../../../AppContext";
import Section from "./Section";

const WorkExchangeMain = ({ navigate, headerValue }) => {
  const { designStyles } = useContext(AppContext);

  return (
    <div className="work-exchange">
      <div className="work-exchange-main">
        <Header navigate={navigate} haveTab={true} headerValue={headerValue} />
        {designStyles?.workExchanges?.map((we) => (
          <Section type={we.value} key={we.value} />
        ))}
      </div>
    </div>
  );
};

WorkExchangeMain.propTypes = {};

export default WorkExchangeMain;
